import React from 'react';
import PropTypes from 'prop-types';

import LanguageConverterV2 from '@careerstart/wae-common/src/main/helperFunction/LanguageConverterV2';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

import { BLACK } from '../../../theme/colorConstants';
import { PRIMARY_FONT } from '../../../theme/fontConstants';
import SectionCard from '../../positionTemplate/components/SectionCard';
import { getSectionAnchorId } from '../constants';

import ChecklistItem, { CHECKLIST_VARIANT } from './ChecklistItem';

const scrollToSection = (sectionId) => {
  document
    .getElementById(getSectionAnchorId(sectionId))
    ?.scrollIntoView({ behavior: 'smooth', block: 'start' });
};

const SectionsNavCard = ({ sections }) => {
  const title = LanguageConverterV2('positionTemplate.create.sections.title');

  return (
    <SectionCard
      header={
        <Typography sx={{ color: BLACK[100], fontFamily: PRIMARY_FONT[700], fontSize: '14px' }}>
          {title}
        </Typography>
      }
    >
      <Box component="nav" aria-label={title} sx={{ margin: '0 -8px', padding: '4px 0' }}>
        {sections.map((section) => (
          <ChecklistItem
            key={section.id}
            labelKey={section.labelKey}
            isComplete={section.isComplete}
            variant={CHECKLIST_VARIANT.NAV}
            onClick={() => scrollToSection(section.id)}
          />
        ))}
      </Box>
    </SectionCard>
  );
};

SectionsNavCard.propTypes = {
  sections: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      labelKey: PropTypes.string.isRequired,
      isComplete: PropTypes.bool.isRequired,
    })
  ).isRequired,
};

export default SectionsNavCard;
